import { createTheme } from "@mui/material";
import { ArrowDownIcon } from "../utils/constants/Icons.constants";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#86D1BB",
      light: "#E5FFF5",
    },
    secondary: {
      main: "#0D0D0E",
      light: "#2E5266",
    },
  },
  typography: {
    fontFamily: "inter",
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
        contained: {
          color: "#fff",
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: () => (
          <ArrowDownIcon
            styles={{ height: "20px", width: "20px", marginRight: "5px" }}
          />
        ),
        inputProps: {
          style: {
            color: "red",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          color: "#4F4F4F",
          fontWeight: "500",
          fontSize: "18px",
          backgroundColor: "#F8F8F8",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        inputProps: {
          style: {
            color: "#232323",
            fontWeight: "400",
            fontSize: "16px",
          },
          fontSize: "18px",
        },
      },
    },
  },
});
